<app-student-module ModuleName="Parent Notification Process" [Loading]="loading" [PrintOptions]="printOptions"
                    [SaveHidden]="false" (Save)="save()">
  <form #initialForm="ngForm" *ngIf="initial" (ngSubmit)="save()">
    <div class="row mb-2">
      <label for="parent_notified" class="col-4 col-md-6 col-sm-12">Parent/Guardian notified on?</label>
      <div class="col-8 col-md-6 col-sm-12">
        <input type="date" name="parent_notified" class="form-control" [(ngModel)]="initial.parent_notified">
      </div>
    </div>
    <div class="row mb-2">
      <label for="share_concern" class="col-4 col-md-6 col-sm-12">Share concern with?</label>
      <div class="col-8 col-md-6 col-sm-12">
        <select class="form-select" name="share_concern" [(ngModel)]="initial.share_concern">
          <option *ngFor="let o of concern" [ngValue]="o">{{ o }}</option>
        </select>
      </div>
    </div>
    <div class="row mb-2">
      <label for="communicator" class="col-4 col-md-6 col-sm-12">Communicator</label>
      <div class="col-8 col-md-6 col-sm-12">
        <staff-select [editable]="true" [multiple]="false" [(selected)]="initial.communicator" [districtId]="districtId"
                      (onChange)="selectInitialStaff($event)"></staff-select>
      </div>
    </div>
    <div class="row mb-2">
      <label for="policies_given" class="col-4 col-md-6 col-sm-12">Policies given to parent/guardian?</label>
      <div class="col-8 col-md-6 col-sm-12">
        <input type="date" name="policies_given" class="form-control" [(ngModel)]="initial.policies_given">
      </div>
    </div>
    <div class="row mb-2d">
      <label for="written_notice" class="col-4 col-md-6 col-sm-12">Written notice provided to parent/guardian?</label>
      <div class="col-8 col-md-6 col-sm-12">
        <input type="date" name="written_notice" class="form-control" [(ngModel)]="initial.written_notice">
      </div>
    </div>
  </form>
</app-student-module>
